import type { ComponentMatrix2BuiltState } from './types';

type ComponentMatrix2EmptyStateArgs = Pick<
  ComponentMatrix2BuiltState,
  'hasReferences' | 'viewSettingsState'
> & {
  itemCount: number;
};

export type ComponentMatrix2EmptyState = {
  noVisibleComponents: boolean;
  noReferencesOrListFields: boolean;
  isEmpty: boolean;
};

export const getComponentMatrix2EmptyState = ({
  itemCount,
  hasReferences,
  viewSettingsState,
}: ComponentMatrix2EmptyStateArgs): ComponentMatrix2EmptyState => {
  const noVisibleComponents = itemCount === 0;
  const noReferencesOrListFields = !(
    hasReferences || viewSettingsState.listFields.length
  );
  return {
    noVisibleComponents,
    noReferencesOrListFields,
    isEmpty: noVisibleComponents || noReferencesOrListFields,
  };
};
